export default {
  goBack: { $call: 'ui.history.goBack' },
};

